import React from 'react';

type Props = {
  className?: string;
};

export default function UIContainer({className, children}: React.PropsWithChildren<Props>) {
  const classes = 'px-14 mx-auto border-box max-w-screen-xl ' + (className || '');
  return (<div className={classes}>{children}</div>)
}
